import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import styled from 'styled-components';

import { Button, Divider, Grid, Typography } from '@material-ui/core';

import CancelIcon from '@material-ui/icons/Cancel';

const DrawerContainer = styled.div`
  width: 415px;
  /* padding: 1.5rem 1.5rem 0.75rem; */
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .buttonsGroup {
  }

  footer {
    padding: 0 2rem 1rem;
    width: 100%;
    .start-button {
      width: 100%;
      margin-top: auto;
      :not(.Mui-disabled) {
        background-color: #5850ec;
        color: #ffffff;
      }
    }
    .exit-btn {
      :not(.Mui-disabled) {
        background-color: #f5f5f5;
        color: #000000;
      }
    }
  }

  .close-btn-text {
    padding: 0 10px;
  }

  .drawer-head {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem;

    .MuiButton-root {
      min-width: auto;
    }
  }

  .divider {
    width: 100%;
  }

  .drawer-body {
    width: 100%;
    height: 100%;
    padding: 0 1rem 1rem;

    .sub-head {
      border-bottom: 1px solid #eeeeee;
      padding: 0.75rem 0;
      margin-bottom: 10px;
    }

    .scrollable {
      max-height: calc(100vh - 180px);
      overflow: auto;
      overflow-x: hidden;

      /* width */
      ::-webkit-scrollbar {
        width: 3px;
      }

      /* Track */
      ::-webkit-scrollbar-track {
        background: #f1f1f100;
      }

      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: #88888829;
      }

      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: #555;
      }
    }

    section {
      padding: 1rem 0 1rem;

      .section-head {
        padding: 0 0 1rem;
      }

      .form {
        width: 100%;
        /* margin: 1.5vh 0; */

        .form-control {
          margin: 1rem 0;
          min-width: 120;
        }

        .MuiFormControl-root {
          width: 100%;
          margin: 0.5rem 0;

          .MuiFormLabel-root {
            /* font-weight: 500;
            font-size: 11px;
            line-height: 13px;
            letter-spacing: 0.33px;
            text-transform: uppercase;
            color: #546e7a; */

            &.Mui-disabled {
              color: rgba(0, 0, 0, 0.38);
            }
          }
          .radio-group {
            padding: 0.5rem 0;

            .MuiFormControlLabel-root {
              width: 50%;
              margin-left: 0;
              margin-right: 0;

              .PrivateSwitchBase-root-518 {
                padding: 9px 9px 9px 0;
              }
            }
          }
        }
      }
    }
  }
`;

export function Sidebar({
  open = false,
  onClose,
  title = '',
  subtitle = '',
  primaryButtonText = 'primary',
  primaryButtonAction,
  primaryButtonDisabled = false,
  secondaryButtonText = 'secondary',
  secondaryButtonAction,
  secondaryButtonDisabled = false,
  children,
  secondaryButtonType,
  variant,
}) {
  const getSecondaryButtonStyles = () => ({
    backgroundColor: secondaryButtonType === 'delete' && '#E53935',
    color: secondaryButtonType === 'delete' && 'white',
  });

  return (
    <Drawer anchor="right" open={open} onClose={onClose} variant={variant}>
      <DrawerContainer>
        <header className="drawer-head">
          <Button variant="text" onClick={onClose}>
            <CancelIcon />
          </Button>
          <Typography variant="h5" color="initial">
            {title}
          </Typography>
        </header>
        <Divider className="divider" />
        <main className="drawer-body">
          {subtitle && (
            <Typography variant="body2" color="initial" className="sub-head">
              {subtitle}
            </Typography>
          )}
          <div className="scrollable">{children}</div>
        </main>
        <footer>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Button
                variant="contained"
                style={getSecondaryButtonStyles()}
                className="start-button exit-btn"
                onClick={secondaryButtonAction}
                disabled={secondaryButtonDisabled}
              >
                {secondaryButtonText}
              </Button>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Button
                variant="contained"
                color="primary"
                className="start-button"
                onClick={primaryButtonAction}
                disabled={primaryButtonDisabled}
              >
                {primaryButtonText}
              </Button>
            </Grid>
          </Grid>
        </footer>
      </DrawerContainer>
    </Drawer>
  );
}
